var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"navbar-nav bg-gradient-light sidebar sidebar-light accordion",attrs:{"id":"accordionSidebar"}},[_c('router-link',{staticClass:"sidebar-brand d-flex align-items-center justify-content-center",attrs:{"to":{ name: 'dashboard' }}},[_c('img',{staticClass:"sidebar-brand-icon",attrs:{"src":require("@/assets/logo-px.png"),"width":"21px","height":"145%"}}),_c('div',{staticClass:"sidebar-brand-text text-primary mx-3 mt-1"},[_c('font',{attrs:{"face":"Netto","size":"5"}},[_vm._v("paxel")])],1)]),_c('hr',{staticClass:"sidebar-divider my-0"}),_c('li',{staticClass:"nav-item",class:{ 'active border-right-active': _vm.routename === 'dashboard' },on:{"mouseover":function($event){_vm.dashboard = true},"mouseleave":function($event){_vm.dashboard = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'dashboard' }}},[(_vm.dashboard || _vm.routename === 'dashboard')?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-dashboard.svg"),"alt":""}}):(_vm.routename != 'dashboard' && !_vm.dashboard)?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-dashboard-unselect.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Dashboard")])])],1),_c('div',[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n      "+_vm._s(_vm.session.role == "superadmin" ? "Super Admin" : "Admin")+"\n    ")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'InternalUser' ||
          _vm.routename === 'addInternalUser' ||
          _vm.routename === 'editInternalUser',
      },on:{"mouseover":function($event){_vm.internal_user = true},"mouseleave":function($event){_vm.internal_user = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'InternalUser' }}},[(
            _vm.internal_user ||
            _vm.routename === 'InternalUser' ||
            _vm.routename === 'addInternalUser' ||
            _vm.routename === 'editInternalUser'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'InternalUser' &&
            _vm.routename != 'addInternalUser' &&
            _vm.routename != 'editInternalUser' &&
            !_vm.internal_user
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Internal User")])])],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.session.role == 'superadmin'),expression:"session.role == 'superadmin'"}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n      Messaging Service\n    ")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'MessageLog',
      },on:{"mouseover":function($event){_vm.message_service = true},"mouseleave":function($event){_vm.message_service = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'MessageLog' }}},[(
            _vm.message_service ||
            _vm.routename === 'MessageLog'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'MessageLog' &&
            !_vm.message_service
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Message Log")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'MessageSettings',
      },on:{"mouseover":function($event){_vm.message_settings = true},"mouseleave":function($event){_vm.message_settings = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'MessageSettings' }}},[(
            _vm.message_settings ||
            _vm.routename === 'MessageSettings'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'MessageSettings' &&
            !_vm.message_settings
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Message Settings")])])],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.session.role == 'superadmin'),expression:"session.role == 'superadmin'"}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("\n      Shortener Service\n    ")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'ShortenerURL',
      },on:{"mouseover":function($event){_vm.shortener_service = true},"mouseleave":function($event){_vm.shortener_service = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'ShortenerURL' }}},[(
            _vm.shortener_service ||
            _vm.routename === 'ShortenerURL'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'ShortenerURL' &&
            !_vm.shortener_service
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Shortener URLs")])])],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.session.role == 'ce' ||
      _vm.session.role == 'superadmin' ||
      _vm.session.role == 'operation' ||
      _vm.session.role == 'finance' ||
      _vm.session.role == 'mentor' ||
      _vm.session.role == 'customer_success' ||
      _vm.session.role == 'claim' ||
      _vm.session.role == 'claim_manager'
    ),expression:"\n      session.role == 'ce' ||\n      session.role == 'superadmin' ||\n      session.role == 'operation' ||\n      session.role == 'finance' ||\n      session.role == 'mentor' ||\n      session.role == 'customer_success' ||\n      session.role == 'claim' ||\n      session.role == 'claim_manager'\n    "}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("CE")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'cxReport' ||
          _vm.routename === 'cxDetailComplaint' ||
          _vm.routename === 'cxDetailClaim' ||
          _vm.routename === 'cxDetailFeedback' ||
          _vm.routename === 'cxDetailInformation',
      },on:{"mouseover":function($event){_vm.cx = true},"mouseleave":function($event){_vm.cx = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'cxReport' }}},[(
            _vm.cx ||
            _vm.routename === 'cxReport' ||
            _vm.routename === 'cxDetailComplaint' ||
            _vm.routename === 'cxDetailClaim' ||
            _vm.routename === 'cxDetailFeedback' ||
            _vm.routename === 'cxDetailInformation'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'cxReport' &&
            _vm.routename != 'cxDetailComplaint' &&
            _vm.routename != 'cxDetailClaim' &&
            _vm.routename != 'cxDetailFeedback' &&
            _vm.routename != 'cxDetailInformation' &&
            !_vm.cx
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Customer Empathy")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'cxAutoClaim' ||
          _vm.routename === 'cxDetailComplaintAutoClaim' ||
          _vm.routename === 'cxDetailAutoClaim' ||
          _vm.routename === 'cxDetailFeedbackAutoClaim' ||
          _vm.routename === 'cxDetailInformationAutoClaim',
      },on:{"mouseover":function($event){_vm.cxAutoClaim = true},"mouseleave":function($event){_vm.cxAutoClaim = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'cxAutoClaim' }}},[(
            _vm.cxAutoClaim ||
            _vm.routename === 'cxAutoClaim' ||
            _vm.routename === 'cxDetailComplaintAutoClaim' ||
            _vm.routename === 'cxDetailAutoClaim' ||
            _vm.routename === 'cxDetailFeedbackAutoClaim' ||
            _vm.routename === 'cxDetailInformationAutoClaim'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'cxAutoClaim' &&
            _vm.routename != 'cxDetailComplaintAutoClaim' &&
            _vm.routename != 'cxDetailAutoClaim' &&
            _vm.routename != 'cxDetailFeedbackAutoClaim' &&
            _vm.routename != 'cxDetailInformationAutoClaim' &&
            !_vm.cxAutoClaim
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Auto Klaim")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'cxInstantClaim' ||
          _vm.routename === 'cxDetailComplaintInstantClaim' ||
          _vm.routename === 'cxDetailInstantClaim' ||
          _vm.routename === 'cxDetailFeedbackInstantClaim' ||
          _vm.routename === 'cxDetailInformationInstantClaim',
      },on:{"mouseover":function($event){_vm.cxInstantClaim = true},"mouseleave":function($event){_vm.cxInstantClaim = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'cxInstantClaim' }}},[(
            _vm.cxInstantClaim ||
            _vm.routename === 'cxInstantClaim' ||
            _vm.routename === 'cxDetailComplaintInstantClaim' ||
            _vm.routename === 'cxDetailInstantClaim' ||
            _vm.routename === 'cxDetailFeedbackInstantClaim' ||
            _vm.routename === 'cxDetailInformationInstantClaim'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'cxInstantClaim' &&
            _vm.routename != 'cxDetailComplaintInstantClaim' &&
            _vm.routename != 'cxDetailInstantClaim' &&
            _vm.routename != 'cxDetailFeedbackInstantClaim' &&
            _vm.routename != 'cxDetailInformationInstantClaim' &&
            !_vm.cxInstantClaim
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Instant Service")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'cxCorporateClaim' ||
          _vm.routename === 'cxDetailComplaintCorporateClaim' ||
          _vm.routename === 'cxDetailCorporateClaim' ||
          _vm.routename === 'cxDetailFeedbackCorporateClaim' ||
          _vm.routename === 'cxDetailInformationCorporateClaim',
      },on:{"mouseover":function($event){_vm.cxCorporateClaim = true},"mouseleave":function($event){_vm.cxCorporateClaim = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'cxCorporateClaim' }}},[(
            _vm.cxCorporateClaim ||
            _vm.routename === 'cxCorporateClaim' ||
            _vm.routename === 'cxDetailComplaintCorporateClaim' ||
            _vm.routename === 'cxDetailCorporateClaim' ||
            _vm.routename === 'cxDetailFeedbackCorporateClaim' ||
            _vm.routename === 'cxDetailInformationCorporateClaim'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'cxCorporateClaim' &&
            _vm.routename != 'cxDetailComplaintCorporateClaim' &&
            _vm.routename != 'cxDetailCorporateClaim' &&
            _vm.routename != 'cxDetailFeedbackCorporateClaim' &&
            _vm.routename != 'cxDetailInformationCorporateClaim' &&
            !_vm.cxCorporateClaim
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Corporate")])])],1),_c('li',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.session.role == 'superadmin' ||
        _vm.session.role == 'claim_manager'
      ),expression:"\n        session.role == 'superadmin' ||\n        session.role == 'claim_manager'\n      "}],staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'claimSettingPINSetting' ||
          _vm.routename === 'claimSettingPaymentLimitation',
      },on:{"mouseover":function($event){_vm.claim_setting = true},"mouseleave":function($event){_vm.claim_setting = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapseClaimSetting","aria-expanded":"true","aria-controls":"collapseClaimSetting"}},[(
            _vm.claim_setting ||
            _vm.routename === 'claimSettingPINSetting' ||
            _vm.routename === 'claimSettingPaymentLimitation'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'claimSettingPINSetting' &&
            _vm.routename != 'claimSettingPaymentLimitation' &&
            !_vm.claim_setting
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Claim Setting")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'claimSettingPINSetting' ||
            _vm.routename === 'claimSettingPaymentLimitation' ||
            _vm.routename === 'claimSettingDisbursementTime'
        },attrs:{"id":"collapseClaimSetting","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'claimSettingPINSetting'
            },attrs:{"to":{ name: 'claimSettingPINSetting' }}},[_vm._v("PIN Setting")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'claimSettingPaymentLimitation'
            },attrs:{"to":{ name: 'claimSettingPaymentLimitation' }}},[_vm._v("Payment Limitation")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'claimSettingDisbursementTime'
            },attrs:{"to":{ name: 'claimSettingDisbursementTime' }}},[_vm._v("Disbursement Time")])],1)])]),_c('li',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.session.role == 'superadmin' ||
        _vm.session.role == 'claim_manager'
      ),expression:"\n        session.role == 'superadmin' ||\n        session.role == 'claim_manager'\n      "}],staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'claimExcess',
      },on:{"mouseover":function($event){_vm.claim_excess = true},"mouseleave":function($event){_vm.claim_excess = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'claimExcess' }}},[(
            _vm.claim_excess ||
            _vm.routename === 'claimExcess'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'claimExcess' &&
            !_vm.claim_excess
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Excess Auto Claim")])])],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.session.role == 'finance' ||
      _vm.session.role == 'ce' ||
      _vm.session.role == 'refund' ||
      _vm.session.role == 'superadmin'
    ),expression:"\n      session.role == 'finance' ||\n      session.role == 'ce' ||\n      session.role == 'refund' ||\n      session.role == 'superadmin'\n    "}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("Finance")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'TransactionLog' ||
          _vm.routename === 'detailTransactionLog',
      },on:{"mouseover":function($event){_vm.transaction_log = true},"mouseleave":function($event){_vm.transaction_log = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'TransactionLog' }}},[(
            _vm.transaction_log ||
            _vm.routename === 'TransactionLog' ||
            _vm.routename === 'detailTransactionLog'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'TransactionLog' &&
            _vm.routename != 'detailTransactionLog' &&
            !_vm.transaction_log
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Transaction Log")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'PaymentInstruction' ||
          _vm.routename === 'editPaymentInstruction',
      },on:{"mouseover":function($event){_vm.payment_instruction = true},"mouseleave":function($event){_vm.payment_instruction = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'PaymentInstruction' }}},[(
            _vm.payment_instruction ||
            _vm.routename === 'PaymentInstruction' ||
            _vm.routename === 'editPaymentInstruction'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'PaymentInstruction' &&
            _vm.routename != 'editPaymentInstruction' &&
            !_vm.payment_instruction
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Payment Instruction")])])],1),_c('li',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.session.role == 'finance' ||
        _vm.session.role == 'refund' ||
        _vm.session.role == 'superadmin'
      ),expression:"\n        session.role == 'finance' ||\n        session.role == 'refund' ||\n        session.role == 'superadmin'\n      "}],staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'PaymentMethod' ||
          _vm.routename === 'createPaymentMethod' ||
          _vm.routename === 'editPaymentMethod' ||
          _vm.routename === 'createProductLocation' ||
          _vm.routename === 'editProductLocation',
      },on:{"mouseover":function($event){_vm.finance = true},"mouseleave":function($event){_vm.finance = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'PaymentMethod' }}},[(
            _vm.finance ||
            _vm.routename === 'PaymentMethod' ||
            _vm.routename === 'createPaymentMethod' ||
            _vm.routename === 'editPaymentMethod' ||
            _vm.routename === 'createProductLocation' ||
            _vm.routename === 'editProductLocation'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'createProductLocation' &&
            _vm.routename != 'editProductLocation' &&
            _vm.routename != 'PaymentMethod' &&
            _vm.routename != 'createPaymentMethod' &&
            _vm.routename != 'editPaymentMethod' &&
            !_vm.finance
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Payment Aggregator")])])],1)]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.session.role == 'finance' ||
      _vm.session.role == 'ce' ||
      _vm.session.role == 'refund' ||
      _vm.session.role == 'superadmin'
    ),expression:"\n      session.role == 'finance' ||\n      session.role == 'ce' ||\n      session.role == 'refund' ||\n      session.role == 'superadmin'\n    "}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("PPOB")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'MasterProvider' ||
          _vm.routename === 'createMasterProvider' ||
          _vm.routename === 'editMasterProvider'||
          _vm.routename === 'PPOBProduct' ||
          _vm.routename === 'createPPOBProduct' ||
          _vm.routename === 'editPPOBProduct' ||
          _vm.routename === 'PPOBTransaction',
      },on:{"mouseover":function($event){_vm.ppob = true},"mouseleave":function($event){_vm.ppob = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapsePPOB","aria-expanded":"true","aria-controls":"collapsePPOB"}},[(
            _vm.ppob ||
            _vm.routename === 'MasterProvider' ||
            _vm.routename === 'createMasterProvider' ||
            _vm.routename === 'editMasterProvider' ||
            _vm.routename === 'PPOBProduct' ||
            _vm.routename === 'createPPOBProduct' ||
            _vm.routename === 'editPPOBProduct' ||
            _vm.routename === 'PPOBTransaction'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'MasterProvider' &&
            _vm.routename != 'createMasterProvider' &&
            _vm.routename != 'editMasterProvider' &&
            _vm.routename != 'PPOBProduct' &&
            _vm.routename != 'createPPOBProduct' &&
            _vm.routename != 'editPPOBProduct' &&
            _vm.routename != 'PPOBTransaction' &&
            !_vm.ppob
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("PPOB")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'MasterProvider' ||
            _vm.routename === 'createMasterProvider' ||
            _vm.routename === 'editMasterProvider' ||
            _vm.routename === 'PPOBProduct' ||
            _vm.routename === 'createPPOBProduct' ||
            _vm.routename === 'editPPOBProduct' ||
            _vm.routename === 'PPOBTransaction'
        },attrs:{"id":"collapsePPOB","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'MasterProvider' ||
                _vm.routename === 'createMasterProvider' ||
                _vm.routename === 'editMasterProvider'
            },attrs:{"to":{ name: 'MasterProvider' }}},[_vm._v("Master Provider")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'PPOBProduct' ||
                _vm.routename === 'createPPOBProduct' ||
                _vm.routename === 'editPPOBProduct'
            },attrs:{"to":{ name: 'PPOBProduct' }}},[_vm._v("Products")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'PPOBTransaction'
            },attrs:{"to":{ name: 'PPOBTransaction' }}},[_vm._v("Transactions")])],1)])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.session.role == 'marketing' || _vm.session.role == 'superadmin'),expression:"session.role == 'marketing' || session.role == 'superadmin'"}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("Marketing")]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'Article' ||
          _vm.routename === 'createArticle' ||
          _vm.routename === 'editArticle',
      },on:{"mouseover":function($event){_vm.article = true},"mouseleave":function($event){_vm.article = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'Article' }}},[(
            _vm.article ||
            _vm.routename === 'Article' ||
            _vm.routename === 'createArticle' ||
            _vm.routename === 'editArticle'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'Article' &&
            _vm.routename != 'createArticle' &&
            _vm.routename != 'editArticle' &&
            !_vm.article
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Article")])])],1),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'Voucher' ||
          _vm.routename === 'ReservationLog' ||
          _vm.routename === 'MyVoucherTab' ||
          _vm.routename === 'ImageURLGenerator' ||
          _vm.routename === 'CreateImageURLGenerator' ||
          _vm.routename === 'EditImageURLGenerator' ||
          _vm.routename === 'SpecialVoucher',
      },on:{"mouseover":function($event){_vm.promo_voucher_setting = true},"mouseleave":function($event){_vm.promo_voucher_setting = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapsePromoVoucherSetting","aria-expanded":"true","aria-controls":"collapsePromoVoucherSetting"}},[(
            _vm.promo_voucher_setting ||
            _vm.routename === 'Voucher' ||
            _vm.routename === 'ReservationLog' ||
            _vm.routename === 'MyVoucherTab' ||
            _vm.routename === 'ImageURLGenerator' ||
            _vm.routename === 'CreateImageURLGenerator' ||
            _vm.routename === 'EditImageURLGenerator' ||
            _vm.routename === 'SpecialVoucher'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'Voucher' &&
            _vm.routename != 'ReservationLog' &&
            _vm.routename != 'MyVoucherTab' &&
            _vm.routename != 'ImageURLGenerator' &&
            _vm.routename !== 'CreateImageURLGenerator' &&
            _vm.routename !== 'EditImageURLGenerator' &&
            _vm.routename !== 'SpecialVoucher' &&
            !_vm.promo_voucher_setting
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Promo")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'Voucher' ||
            _vm.routename === 'ReservationLog' ||
            _vm.routename === 'MyVoucherTab' ||
            _vm.routename === 'ImageURLGenerator' ||
            _vm.routename === 'CreateImageURLGenerator' ||
            _vm.routename === 'EditImageURLGenerator' ||
            _vm.routename === 'SpecialVoucher',
        },attrs:{"id":"collapsePromoVoucherSetting","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Voucher',
            },attrs:{"to":{ name: 'Voucher' }}},[_vm._v("\n            Voucher\n          ")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'ReservationLog',
            },attrs:{"to":{ name: 'ReservationLog' }}},[_vm._v("\n            Reservation Log\n          ")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'MyVoucherTab',
            },attrs:{"to":{ name: 'MyVoucherTab' }}},[_vm._v("\n            My Voucher Tab\n          ")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'SpecialVoucher',
            },attrs:{"to":{ name: 'SpecialVoucher' }}},[_vm._v("\n            Special Voucher\n          ")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'ImageURLGenerator' ||
                _vm.routename === 'CreateImageURLGenerator' ||
                _vm.routename === 'EditImageURLGenerator',
            },attrs:{"to":{ name: 'ImageURLGenerator' }}},[_vm._v("\n            Image URL Generator\n          ")])],1)])]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'editGuestBook' ||
          _vm.routename === 'bannerLocker' ||
          _vm.routename === 'createBannerLocker' ||
          _vm.routename === 'editBannerLocker' ||
          _vm.routename === 'servicesLocker' ||
          _vm.routename === 'createServicesLocker' ||
          _vm.routename === 'editServicesLocker' ||
          _vm.routename === 'bannerMitraPaxel' ||
          _vm.routename === 'customerList' ||
          _vm.routename === 'detailCustomer' ||
          _vm.routename === 'TncContent' ||
          _vm.routename === 'createTncContent' ||
          _vm.routename === 'editTncContent' ||
          _vm.routename === 'TncCategory' ||
          _vm.routename === 'createTncCategory' ||
          _vm.routename === 'editTncCategory' ||
          _vm.routename === 'PartnerList' ||
          _vm.routename === 'createPartnerList' ||
          _vm.routename === 'editPartnerList' ||
          _vm.routename === 'bannerOurPartner' ||
          _vm.routename === 'createBannerOurPartner' ||
          _vm.routename === 'editBannerOurPartner' ||
          _vm.routename === 'AntarkankebaikanPartner' ||
          _vm.routename === 'createAntarkankebaikanPartner' ||
          _vm.routename === 'editAntarkankebaikanPartner' ||
          _vm.routename === 'editBannerAntarkanKebaikan' ||
          _vm.routename === 'createPartnershipKontak' ||
          _vm.routename === 'editPartnershipKontak' ||
          _vm.routename === 'PartnershipKontak' ||
          _vm.routename === 'editPartnershipBanner' ||
          _vm.routename === 'editBannerNewsPromo' ||
          _vm.routename === 'editBannerOurService' ||
          _vm.routename === 'editBannerAboutUs' ||
          _vm.routename === 'Banner' ||
          _vm.routename === 'createBanner' ||
          _vm.routename === 'editBanner' ||
          _vm.routename === 'PartnershipExcellence' ||
          _vm.routename === 'PartnershipTestimonial' ||
          _vm.routename === 'createPartnershipExcellence' ||
          _vm.routename === 'editPartnershipExcellence' ||
          _vm.routename === 'createPartnershipTestimonial' ||
          _vm.routename === 'editPartnershipTestimonial' ||
          _vm.routename === 'PartnerList' ||
          _vm.routename === 'editPartnerList' ||
          _vm.routename === 'createPartnerList' ||
          _vm.routename === 'PaxelcoDashboard' ||
          _vm.routename === 'OurPartners' ||
          _vm.routename === 'createOurPartners' ||
          _vm.routename === 'editOurPartners' ||
          _vm.routename === 'OurServiceValues' ||
          _vm.routename === 'editOurServiceValues' ||
          _vm.routename === 'createOurServiceValues' ||
          _vm.routename === 'homePage' ||
          _vm.routename === 'TncWeb' ||
          _vm.routename === 'TncUser' ||
          _vm.routename === 'TncHero' ||
          _vm.routename === 'FaqCategory' ||
          _vm.routename === 'FaqContent' ||
          _vm.routename === 'createFaq' ||
          _vm.routename === 'editFaq' ||
          _vm.routename === 'createFaqCategory' ||
          _vm.routename === 'editFaqCategory' ||
          _vm.routename === 'createTnc' ||
          _vm.routename === 'editTnc' ||
          _vm.routename === 'editHomePage' ||
          _vm.routename === 'createHomePage' ||
          _vm.routename === 'Aboutus' ||
          _vm.routename === 'createAboutus' ||
          _vm.routename === 'editAboutus' ||
          _vm.routename === 'Privacypolicy' ||
          _vm.routename === 'editPrivacypolicy' ||
          _vm.routename === 'createPrivacypolicy' ||
          _vm.routename === 'OurService' ||
          _vm.routename === 'createOurService' ||
          _vm.routename === 'editOurService' ||
          _vm.routename === 'bannerCorpSales' ||
          _vm.routename === 'CorpSalesExcellence' ||
          _vm.routename === 'CorpSalesTestimonial' ||
          _vm.routename === 'createCorpSalesExcellence' ||
          _vm.routename === 'editCorpSalesExcellence' ||
          _vm.routename === 'createCorpSalesTestimonial' ||
          _vm.routename === 'editCorpSalesTestimonial' ||
          _vm.routename === 'CorpPartnerList' ||
          _vm.routename === 'editCorpPartnerList' ||
          _vm.routename === 'createCorpPartnerList'||
          _vm.routename === 'BigBanner' ||
          _vm.routename === 'FlowBig' ||
          _vm.routename === 'BigCustomerList' ||
          _vm.routename === 'createBigCustomerList' ||
          _vm.routename === 'editBigCustomerList' ||
          _vm.routename === 'BigExcellence' ||
          _vm.routename === 'createBigExcellence' ||
          _vm.routename === 'footNote'||
          _vm.routename === 'editBannerOurService'||
          _vm.routename === 'editBigExcellence'||
          _vm.routename === 'Captcha'||
          _vm.routename === 'createCaptcha' ||
          _vm.routename === 'editCaptcha' ||
          _vm.routename === 'BigRegistrationButton' ||
          _vm.routename === 'GlobalSearch'||
          _vm.routename === 'createGlobalSearch' ||
          _vm.routename === 'editGlobalSearch' ||
          _vm.routename === 'PaxelMarketMainHeader' ||
          _vm.routename === 'PaxelMarketMeta' ||
          _vm.routename === 'PaxelMarketBasicService' ||
          _vm.routename === 'createPaxelMarketBasicService' ||
          _vm.routename === 'editPaxelMarketBasicService' ||
          _vm.routename === 'PaxelMarketMainFeatures' ||
          _vm.routename === 'createPaxelMarketMainFeatures' ||
          _vm.routename === 'editPaxelMarketMainFeatures' ||
          _vm.routename === 'PaxelMarketJoinProcedure' ||
          _vm.routename === 'createPaxelMarketJoinProcedure' ||
          _vm.routename === 'editPaxelMarketJoinProcedure' ||
          _vm.routename === 'PaxelMarketSOP' ||
          _vm.routename === 'createPaxelMarketSOP' ||
          _vm.routename === 'editPaxelMarketSOP' ||
          _vm.routename === 'PaxelMarketPartners' ||
          _vm.routename === 'createPaxelMarketPartners' ||
          _vm.routename === 'editPaxelMarketPartners'
      },on:{"mouseover":function($event){_vm.paxelco = true},"mouseleave":function($event){_vm.paxelco = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapsePaxelco","aria-expanded":"true","aria-controls":"collapsePaxelco"}},[(
            _vm.paxelco ||
            _vm.routename === 'editGuestBook' ||
            _vm.routename === 'bannerLocker' ||
            _vm.routename === 'createBannerLocker' ||
            _vm.routename === 'editBannerLocker' ||
            _vm.routename === 'servicesLocker' ||
            _vm.routename === 'createServicesLocker' ||
            _vm.routename === 'editServicesLocker' ||
            _vm.routename === 'bannerMitraPaxel' ||
            _vm.routename === 'customerList' ||
            _vm.routename === 'detailCustomer' ||
            _vm.routename === 'TncContent' ||
            _vm.routename === 'createTncContent' ||
            _vm.routename === 'editTncContent' ||
            _vm.routename === 'TncCategory' ||
            _vm.routename === 'createTncCategory' ||
            _vm.routename === 'editTncCategory' ||
            _vm.routename === 'PartnerList' ||
            _vm.routename === 'createPartnerList' ||
            _vm.routename === 'editPartnerList' ||
            _vm.routename === 'bannerOurPartner' ||
            _vm.routename === 'createBannerOurPartner' ||
            _vm.routename === 'editBannerOurPartner' ||
            _vm.routename === 'AntarkankebaikanPartner' ||
            _vm.routename === 'createAntarkankebaikanPartner' ||
            _vm.routename === 'editAntarkankebaikanPartner' ||
            _vm.routename === 'editBannerAntarkanKebaikan' ||
            _vm.routename === 'createPartnershipKontak' ||
            _vm.routename === 'editPartnershipKontak' ||
            _vm.routename === 'PartnershipKontak' ||
            _vm.routename === 'editPartnershipBanner' ||
            _vm.routename === 'editBannerNewsPromo' ||
            _vm.routename === 'editBannerOurService' ||
            _vm.routename === 'editBannerAboutUs' ||
            _vm.routename === 'Banner' ||
            _vm.routename === 'createBanner' ||
            _vm.routename === 'editBanner' ||
            _vm.routename === 'PartnershipExcellence' ||
            _vm.routename === 'PartnershipTestimonial' ||
            _vm.routename === 'createPartnershipExcellence' ||
            _vm.routename === 'editPartnershipExcellence' ||
            _vm.routename === 'createPartnershipTestimonial' ||
            _vm.routename === 'editPartnershipTestimonial' ||
            _vm.routename === 'PartnerList' ||
            _vm.routename === 'editPartnerList' ||
            _vm.routename === 'createPartnerList' ||
            _vm.routename === 'PaxelcoDashboard' ||
            _vm.routename === 'OurPartners' ||
            _vm.routename === 'createOurPartners' ||
            _vm.routename === 'editOurPartners' ||
            _vm.routename === 'OurServiceValues' ||
            _vm.routename === 'editOurServiceValues' ||
            _vm.routename === 'createOurServiceValues' ||
            _vm.routename === 'homePage' ||
            _vm.routename === 'TncWeb' ||
            _vm.routename === 'TncUser' ||
            _vm.routename === 'TncHero' ||
            _vm.routename === 'FaqCategory' ||
            _vm.routename === 'FaqContent' ||
            _vm.routename === 'createFaq' ||
            _vm.routename === 'editFaq' ||
            _vm.routename === 'createFaqCategory' ||
            _vm.routename === 'editFaqCategory' ||
            _vm.routename === 'createTnc' ||
            _vm.routename === 'editTnc' ||
            _vm.routename === 'editHomePage' ||
            _vm.routename === 'createHomePage' ||
            _vm.routename === 'Aboutus' ||
            _vm.routename === 'createAboutus' ||
            _vm.routename === 'editAboutus' ||
            _vm.routename === 'Privacypolicy' ||
            _vm.routename === 'editPrivacypolicy' ||
            _vm.routename === 'createPrivacypolicy' ||
            _vm.routename === 'OurService' ||
            _vm.routename === 'createOurService' ||
            _vm.routename === 'editOurService' ||
            _vm.routename === 'bannerCorpSales' ||
            _vm.routename === 'CorpSalesExcellence' ||
            _vm.routename === 'CorpSalesTestimonial' ||
            _vm.routename === 'createCorpSalesExcellence' ||
            _vm.routename === 'editCorpSalesExcellence' ||
            _vm.routename === 'createCorpSalesTestimonial' ||
            _vm.routename === 'editCorpSalesTestimonial' ||
            _vm.routename === 'CorpPartnerList' ||
            _vm.routename === 'editCorpPartnerList' ||
            _vm.routename === 'createCorpPartnerList' ||
            _vm.routename === 'BigBanner' ||
            _vm.routename === 'FlowBig' ||
            _vm.routename === 'BigCustomerList' ||
            _vm.routename === 'createBigCustomerList' ||
            _vm.routename === 'editBigCustomerList' ||
            _vm.routename === 'BigExcellence' ||
            _vm.routename === 'createBigExcellence' ||
            _vm.routename === 'footNote'||
            _vm.routename === 'editBannerOurService'||
            _vm.routename === 'editBigExcellence'||
            _vm.routename === 'Captcha'||
            _vm.routename === 'createCaptcha' ||
            _vm.routename === 'editCaptcha' ||
            _vm.routename === 'BigRegistrationButton' ||
            _vm.routename === 'GlobalSearch' ||
            _vm.routename === 'createGlobalSearch' ||
            _vm.routename === 'editGlobalSearch' ||
            _vm.routename === 'PaxelMarketMainHeader' ||
            _vm.routename === 'PaxelMarketMeta' ||
            _vm.routename === 'PaxelMarketBasicService' ||
            _vm.routename === 'createPaxelMarketBasicService' ||
            _vm.routename === 'editPaxelMarketBasicService' ||
            _vm.routename === 'PaxelMarketMainFeatures' ||
            _vm.routename === 'createPaxelMarketMainFeatures' ||
            _vm.routename === 'editPaxelMarketMainFeatures' ||
            _vm.routename === 'PaxelMarketJoinProcedure' ||
            _vm.routename === 'createPaxelMarketJoinProcedure' ||
            _vm.routename === 'editPaxelMarketJoinProcedure' ||
            _vm.routename === 'PaxelMarketSOP' ||
          _vm.routename === 'createPaxelMarketSOP' ||
          _vm.routename === 'editPaxelMarketSOP' ||
            _vm.routename === 'PaxelMarketPartners' ||
            _vm.routename === 'createPaxelMarketPartners' ||
            _vm.routename === 'editPaxelMarketPartners'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'editGuestBook' &&
            _vm.routename != 'bannerLocker' &&
            _vm.routename != 'createBannerLocker' &&
            _vm.routename != 'editBannerLocker' &&
            _vm.routename != 'servicesLocker' &&
            _vm.routename != 'createServicesLocker' &&
            _vm.routename != 'editServicesLocker' &&
            _vm.routename != 'bannerMitraPaxel' &&
            _vm.routename != 'customerList' &&
            _vm.routename != 'detailCustomer' &&
            _vm.routename != 'TncContent' &&
            _vm.routename != 'createTncContent' &&
            _vm.routename != 'editTncContent' &&
            _vm.routename != 'TncCategory' &&
            _vm.routename != 'createTncCategory' &&
            _vm.routename != 'editTncCategory' &&
            _vm.routename != 'PartnerList' &&
            _vm.routename != 'createPartnerList' &&
            _vm.routename != 'editPartnerList' &&
            _vm.routename != 'bannerOurPartner' &&
            _vm.routename != 'createBannerOurPartner' &&
            _vm.routename != 'editBannerOurPartner' &&
            _vm.routename != 'AntarkankebaikanPartner' &&
            _vm.routename != 'createAntarkankebaikanPartner' &&
            _vm.routename != 'editAntarkankebaikanPartner' &&
            _vm.routename != 'editBannerAntarkanKebaikan' &&
            _vm.routename != 'createPartnershipKontak' &&
            _vm.routename != 'editPartnershipKontak' &&
            _vm.routename != 'PartnershipKontak' &&
            _vm.routename != 'editPartnershipBanner' &&
            _vm.routename != 'editBannerNewsPromo' &&
            _vm.routename != 'editBannerOurService' &&
            _vm.routename != 'editBannerAboutUs' &&
            _vm.routename != 'Banner' &&
            _vm.routename != 'createBanner' &&
            _vm.routename != 'editBanner' &&
            _vm.routename != 'PartnershipExcellence' &&
            _vm.routename != 'PartnershipTestimonial' &&
            _vm.routename != 'createPartnershipExcellence' &&
            _vm.routename != 'editPartnershipExcellence' &&
            _vm.routename != 'createPartnershipTestimonial' &&
            _vm.routename != 'editPartnershipTestimonial' &&
            _vm.routename != 'PartnerList' &&
            _vm.routename != 'editPartnerList' &&
            _vm.routename != 'createPartnerList' &&
            _vm.routename != 'PaxelcoDashboard' &&
            _vm.routename != 'OurPartners' &&
            _vm.routename != 'createOurPartners' &&
            _vm.routename != 'editOurPartners' &&
            _vm.routename != 'OurServiceValues' &&
            _vm.routename != 'editOurServiceValues' &&
            _vm.routename != 'createOurServiceValues' &&
            _vm.routename != 'homePage' &&
            _vm.routename != 'TncWeb' &&
            _vm.routename != 'TncUser' &&
            _vm.routename != 'TncHero' &&
            _vm.routename != 'FaqCategory' &&
            _vm.routename != 'FaqContent' &&
            _vm.routename != 'createFaq' &&
            _vm.routename != 'editFaq' &&
            _vm.routename != 'createFaqCategory' &&
            _vm.routename != 'editFaqCategory' &&
            _vm.routename != 'createTnc' &&
            _vm.routename != 'editTnc' &&
            _vm.routename != 'editHomePage' &&
            _vm.routename != 'createHomePage' &&
            _vm.routename != 'Aboutus' &&
            _vm.routename != 'createAboutus' &&
            _vm.routename != 'editAboutus' &&
            _vm.routename != 'Privacypolicy' &&
            _vm.routename != 'editPrivacypolicy' &&
            _vm.routename != 'createPrivacypolicy' &&
            _vm.routename != 'OurService' &&
            _vm.routename != 'createOurService' &&
            _vm.routename != 'editOurService' &&
            _vm.routename != 'CorpSalesExcellence' &&
            _vm.routename != 'CorpSalesTestimonial' &&
            _vm.routename != 'createCorpSalesExcellence' &&
            _vm.routename != 'editCorpSalesExcellence' &&
            _vm.routename != 'createCorpSalesTestimonial' &&
            _vm.routename != 'editCorpSalesTestimonial' &&
            _vm.routename != 'CorpPartnerList' &&
            _vm.routename != 'editCorpPartnerList' &&
            _vm.routename != 'createCorpPartnerList' &&
            _vm.routename != 'bannerCorpSales' &&
            _vm.routename != 'BigBanner' &&
            _vm.routename != 'FlowBig' &&
            _vm.routename != 'BigCustomerList' &&
            _vm.routename != 'createBigCustomerList' &&
            _vm.routename != 'editBigCustomerList' &&
            _vm.routename != 'BigExcellence' &&
            _vm.routename != 'createBigExcellence' &&
            _vm.routename != 'editBigExcellence' &&
            _vm.routename != 'footNote' &&
            _vm.routename != 'editBannerOurService' &&
            _vm.routename != 'Captcha'&&
            _vm.routename != 'createCaptcha' &&
            _vm.routename != 'editCaptcha'&&
            _vm.routename != 'BigRegistrationButton' &&
            _vm.routename != 'GlobalSearch' &&
            _vm.routename != 'createGlobalSearch' &&
            _vm.routename != 'editGlobalSearch' &&
            _vm.routename != 'PaxelMarketMainHeader' &&
            _vm.routename != 'PaxelMarketMeta' &&
            _vm.routename != 'PaxelMarketBasicService' &&
            _vm.routename != 'createPaxelMarketBasicService' &&
            _vm.routename != 'editPaxelMarketBasicService' &&
            _vm.routename != 'PaxelMarketMainFeatures' &&
            _vm.routename != 'createPaxelMarketMainFeatures' &&
            _vm.routename != 'editPaxelMarketMainFeatures' &&
            _vm.routename != 'PaxelMarketJoinProcedure' &&
            _vm.routename != 'createPaxelMarketJoinProcedure' &&
            _vm.routename != 'editPaxelMarketJoinProcedure' &&
            _vm.routename != 'PaxelMarketSOP' &&
            _vm.routename != 'createPaxelMarketSOP' &&
            _vm.routename != 'editPaxelMarketSOP' &&
            _vm.routename != 'PaxelMarketPartners' &&
            _vm.routename != 'createPaxelMarketPartners' &&
            _vm.routename != 'editPaxelMarketPartners' &&
            !_vm.paxelco
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Website Content")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'editGuestBook' ||
            _vm.routename === 'bannerLocker' ||
            _vm.routename === 'createBannerLocker' ||
            _vm.routename === 'editBannerLocker' ||
            _vm.routename === 'servicesLocker' ||
            _vm.routename === 'createServicesLocker' ||
            _vm.routename === 'editServicesLocker' ||
            _vm.routename === 'bannerMitraPaxel' ||
            _vm.routename === 'customerList' ||
            _vm.routename === 'detailCustomer' ||
            _vm.routename === 'TncContent' ||
            _vm.routename === 'createTncContent' ||
            _vm.routename === 'editTncContent' ||
            _vm.routename === 'TncCategory' ||
            _vm.routename === 'createTncCategory' ||
            _vm.routename === 'editTncCategory' ||
            _vm.routename === 'PartnerList' ||
            _vm.routename === 'createPartnerList' ||
            _vm.routename === 'editPartnerList' ||
            _vm.routename === 'bannerOurPartner' ||
            _vm.routename === 'createBannerOurPartner' ||
            _vm.routename === 'editBannerOurPartner' ||
            _vm.routename === 'AntarkankebaikanPartner' ||
            _vm.routename === 'createAntarkankebaikanPartner' ||
            _vm.routename === 'editAntarkankebaikanPartner' ||
            _vm.routename === 'editBannerAntarkanKebaikan' ||
            _vm.routename === 'createPartnershipKontak' ||
            _vm.routename === 'editPartnershipKontak' ||
            _vm.routename === 'PartnershipKontak' ||
            _vm.routename === 'editPartnershipBanner' ||
            _vm.routename === 'editBannerNewsPromo' ||
            _vm.routename === 'editBannerOurService' ||
            _vm.routename === 'editBannerAboutUs' ||
            _vm.routename === 'Banner' ||
            _vm.routename === 'createBanner' ||
            _vm.routename === 'editBanner' ||
            _vm.routename === 'PartnershipExcellence' ||
            _vm.routename === 'PartnershipTestimonial' ||
            _vm.routename === 'createPartnershipExcellence' ||
            _vm.routename === 'editPartnershipExcellence' ||
            _vm.routename === 'createPartnershipTestimonial' ||
            _vm.routename === 'editPartnershipTestimonial' ||
            _vm.routename === 'PartnerList' ||
            _vm.routename === 'editPartnerList' ||
            _vm.routename === 'createPartnerList' ||
            _vm.routename === 'PaxelcoDashboard' ||
            _vm.routename === 'OurPartners' ||
            _vm.routename === 'createOurPartners' ||
            _vm.routename === 'editOurPartners' ||
            _vm.routename === 'TncWeb' ||
            _vm.routename === 'TncUser' ||
            _vm.routename === 'TncHero' ||
            _vm.routename === 'OurServiceValues' ||
            _vm.routename === 'editOurServiceValues' ||
            _vm.routename === 'createOurServiceValues' ||
            _vm.routename === 'homePage' ||
            _vm.routename === 'Tnc' ||
            _vm.routename === 'FaqCategory' ||
            _vm.routename === 'FaqContent' ||
            _vm.routename === 'createFaq' ||
            _vm.routename === 'editFaq' ||
            _vm.routename === 'createFaqCategory' ||
            _vm.routename === 'editFaqCategory' ||
            _vm.routename === 'createTnc' ||
            _vm.routename === 'editTnc' ||
            _vm.routename === 'editHomePage' ||
            _vm.routename === 'createHomePage' ||
            _vm.routename === 'Aboutus' ||
            _vm.routename === 'createAboutus' ||
            _vm.routename === 'editAboutus' ||
            _vm.routename === 'Privacypolicy' ||
            _vm.routename === 'editPrivacypolicy' ||
            _vm.routename === 'createPrivacypolicy' ||
            _vm.routename === 'OurService' ||
            _vm.routename === 'createOurService' ||
            _vm.routename === 'editOurService' ||
            _vm.routename === 'CorpSalesExcellence' ||
            _vm.routename === 'CorpSalesTestimonial' ||
            _vm.routename === 'createCorpSalesExcellence' ||
            _vm.routename === 'editCorpSalesExcellence' ||
            _vm.routename === 'createCorpSalesTestimonial' ||
            _vm.routename === 'editCorpSalesTestimonial' ||
            _vm.routename === 'bannerCorpSales' ||
            _vm.routename === 'CorpPartnerList' ||
            _vm.routename === 'editCorpPartnerList' ||
            _vm.routename === 'createCorpPartnerList' ||
            _vm.routename === 'BigBanner' ||
            _vm.routename === 'FlowBig' ||
            _vm.routename === 'BigCustomerList' ||
            _vm.routename === 'createBigCustomerList' ||
            _vm.routename === 'editBigCustomerList' ||
            _vm.routename === 'BigExcellence' ||
            _vm.routename === 'createBigExcellence' ||
            _vm.routename === 'footNote'||
            _vm.routename === 'editBannerOurService'||
            _vm.routename === 'editBigExcellence'||
            _vm.routename === 'Captcha'||
            _vm.routename === 'createCaptcha' ||
            _vm.routename === 'editCaptcha' ||
            _vm.routename === 'editBannerDownload' ||
            _vm.routename === 'BigRegistrationButton' ||
            _vm.routename === 'PaxelRecycleMeta' ||
            _vm.routename === 'PaxelRecycleBanner' ||
            _vm.routename === 'PaxelRecycleReason' ||
            _vm.routename === 'createPaxelRecycleReason' ||
            _vm.routename === 'editPaxelRecycleReason' ||
            _vm.routename === 'PaxelRecycleWasteType' ||
            _vm.routename === 'createPaxelRecycleWasteType' ||
            _vm.routename === 'editPaxelRecycleWasteType' ||
            _vm.routename === 'PaxelRecycleBeforeSending' ||
            _vm.routename === 'PaxelRecycleHowTo' ||
            _vm.routename === 'createPaxelRecycleHowTo' ||
            _vm.routename === 'editPaxelRecycleHowTo' ||
            _vm.routename === 'PaxelRecycleTutorial' ||
            _vm.routename === 'PaxelRecycleCoverage' ||
            _vm.routename === 'PaxelRecycleMoreInfo' ||
            _vm.routename === 'PejuangOnlineBanner' ||
            _vm.routename === 'GlobalSearch' ||
            _vm.routename === 'createGlobalSearch' ||
            _vm.routename === 'editGlobalSearch' ||
            _vm.routename === 'PaxelMarketMainHeader' ||
            _vm.routename === 'PaxelMarketMeta' ||
            _vm.routename === 'PaxelMarketBasicService' ||
            _vm.routename === 'createPaxelMarketBasicService' ||
            _vm.routename === 'editPaxelMarketBasicService' ||
            _vm.routename === 'PaxelMarketMainFeatures' ||
            _vm.routename === 'createPaxelMarketMainFeatures' ||
            _vm.routename === 'editPaxelMarketMainFeatures' ||
            _vm.routename === 'PaxelMarketJoinProcedure' ||
            _vm.routename === 'createPaxelMarketJoinProcedure' ||
            _vm.routename === 'editPaxelMarketJoinProcedure' ||
            _vm.routename === 'PaxelMarketSOP' ||
          _vm.routename === 'createPaxelMarketSOP' ||
          _vm.routename === 'editPaxelMarketSOP' ||
            _vm.routename === 'PaxelMarketPartners' ||
            _vm.routename === 'createPaxelMarketPartners' ||
            _vm.routename === 'editPaxelMarketPartners',
        },attrs:{"id":"collapsePaxelco","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'homePage' ||
                  _vm.routename === 'editHomePage' ||
                  _vm.routename === 'createHomePage' ||
                  _vm.routename === 'footNote' ||
                  _vm.routename === 'PaxelcoDashboard'||
                  _vm.routename === 'Captcha'||
                  _vm.routename === 'createCaptcha' ||
                  _vm.routename === 'editCaptcha',
              },attrs:{"data-toggle":"collapse","href":"#HomepageCollapse","aria-expanded":"true","aria-controls":"HomepageCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'homePage' &&
                    _vm.routename != 'editHomePage' &&
                    _vm.routename != 'createHomePage' &&
                    _vm.routename != 'footNote' &&
                    _vm.routename != 'PaxelcoDashboard'&&
                    _vm.routename != 'Captcha'&&
                    _vm.routename != 'createCaptcha' &&
                    _vm.routename != 'editCaptcha',
                }},[_vm._v("Homepage")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'homePage' ||
                _vm.routename === 'editHomePage' ||
                _vm.routename === 'createHomePage' ||
                _vm.routename === 'PaxelcoDashboard',
            },attrs:{"id":"HomepageCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'homePage' ||
                  _vm.routename === 'editHomePage' ||
                  _vm.routename === 'createHomePage',
              },attrs:{"to":{ name: 'homePage' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Top Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelcoDashboard',
              },attrs:{"to":{ name: 'PaxelcoDashboard' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Infografis")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'footNote',
              },attrs:{"to":{ name: 'footNote' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Footnote")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'Captcha'||
                  _vm.routename === 'createCaptcha' ||
                  _vm.routename === 'editCaptcha',
              },attrs:{"to":{ name: 'Captcha' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Captcha Image")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'OurService' ||
                  _vm.routename === 'createOurService' ||
                  _vm.routename === 'editOurService' ||
                  _vm.routename === 'editBannerOurService',
              },attrs:{"data-toggle":"collapse","href":"#OurServiceCollapse","aria-expanded":"true","aria-controls":"OurServiceCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'OurService' &&
                    _vm.routename != 'createOurService' &&
                    _vm.routename != 'editOurService' &&
                    _vm.routename != 'editBannerOurService',
                }},[_vm._v("Layanan Kami")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'OurService' ||
                _vm.routename === 'createOurService' ||
                _vm.routename === 'editOurService' ||
                _vm.routename === 'editBannerOurService',
            },attrs:{"id":"OurServiceCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'editBannerOurService',
              },attrs:{"to":{ name: 'editBannerOurService' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'OurService' ||
                  _vm.routename === 'createOurService' ||
                  _vm.routename === 'editOurService',
              },attrs:{"to":{ name: 'OurService' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Content")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'Aboutus' ||
                  _vm.routename === 'createAboutus' ||
                  _vm.routename === 'editAboutus' ||
                  _vm.routename === 'editBannerAboutUs',
              },attrs:{"data-toggle":"collapse","href":"#AboutUsCollapse","aria-expanded":"true","aria-controls":"AboutUsCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'Aboutus' &&
                    _vm.routename != 'createAboutus' &&
                    _vm.routename != 'editAboutus' &&
                    _vm.routename != 'editBannerAboutUs',
                }},[_vm._v("Tentang Kami")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'Aboutus' ||
                _vm.routename === 'createAboutus' ||
                _vm.routename === 'editAboutus' ||
                _vm.routename === 'editBannerAboutUs',
            },attrs:{"id":"AboutUsCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'editBannerAboutUs',
              },attrs:{"to":{ name: 'editBannerAboutUs' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'Aboutus' ||
                  _vm.routename === 'createAboutus' ||
                  _vm.routename === 'editAboutus',
              },attrs:{"to":{ name: 'Aboutus' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Content")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'PaxelRecycleMeta' ||
                  _vm.routename === 'PaxelRecycleBanner' ||
                  _vm.routename === 'PaxelRecycleReason' ||
                  _vm.routename === 'createPaxelRecycleReason' ||
                  _vm.routename === 'editPaxelRecycleReason' ||
                  _vm.routename === 'PaxelRecycleWasteType' ||
                  _vm.routename === 'createPaxelRecycleWasteType' ||
                  _vm.routename === 'editPaxelRecycleWasteType' ||
                  _vm.routename === 'PaxelRecycleBeforeSending' ||
                  _vm.routename === 'PaxelRecycleHowTo' ||
                  _vm.routename === 'createPaxelRecycleHowTo' ||
                  _vm.routename === 'editPaxelRecycleHowTo' ||
                  _vm.routename === 'PaxelRecycleTutorial' ||
                  _vm.routename === 'PaxelRecycleCoverage' ||
                  _vm.routename === 'PaxelRecycleMoreInfo',
              },attrs:{"data-toggle":"collapse","href":"#PaxelRecycleCollapse","aria-expanded":"true","aria-controls":"PaxelRecycleCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'PaxelRecycleMeta' &&
                    _vm.routename != 'PaxelRecycleBanner' &&
                    _vm.routename != 'PaxelRecycleReason' &&
                    _vm.routename != 'createPaxelRecycleReason' &&
                    _vm.routename != 'editPaxelRecycleReason' &&
                    _vm.routename != 'PaxelRecycleWasteType' &&
                    _vm.routename != 'createPaxelRecycleWasteType' &&
                    _vm.routename != 'editPaxelRecycleWasteType' &&
                    _vm.routename != 'PaxelRecycleBeforeSending' &&
                    _vm.routename != 'PaxelRecycleHowTo' &&
                    _vm.routename != 'createPaxelRecycleHowTo' &&
                    _vm.routename != 'editPaxelRecycleHowTo' &&
                    _vm.routename != 'PaxelRecycleTutorial' &&
                    _vm.routename != 'PaxelRecycleCoverage' &&
                    _vm.routename != 'PaxelRecycleMoreInfo',
                }},[_vm._v("Paxel Recycle")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'PaxelRecycleMeta' ||
                _vm.routename === 'PaxelRecycleBanner' ||
                _vm.routename === 'PaxelRecycleReason' ||
                _vm.routename === 'createPaxelRecycleReason' ||
                _vm.routename === 'editPaxelRecycleReason'||
                _vm.routename === 'PaxelRecycleWasteType' ||
                _vm.routename === 'createPaxelRecycleWasteType' ||
                _vm.routename === 'editPaxelRecycleWasteType' ||
                _vm.routename === 'PaxelRecycleBeforeSending' ||
                _vm.routename === 'PaxelRecycleHowTo' ||
                _vm.routename === 'createPaxelRecycleHowTo' ||
                _vm.routename === 'editPaxelRecycleHowTo' ||
                _vm.routename === 'PaxelRecycleTutorial' ||
                _vm.routename === 'PaxelRecycleCoverage' ||
                _vm.routename === 'PaxelRecycleMoreInfo',
            },attrs:{"id":"PaxelRecycleCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleMeta',
              },attrs:{"to":{ name: 'PaxelRecycleMeta' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Meta")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleBanner',
              },attrs:{"to":{ name: 'PaxelRecycleBanner' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': 
                _vm.routename === 'PaxelRecycleReason' ||
                _vm.routename === 'createPaxelRecycleReason' ||
                _vm.routename === 'editPaxelRecycleReason',
              },attrs:{"to":{ name: 'PaxelRecycleReason' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Why PaxelRecycle")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': 
                _vm.routename === 'PaxelRecycleWasteType' ||
                _vm.routename === 'createPaxelRecycleWasteType' ||
                _vm.routename === 'editPaxelRecycleWasteType',
              },attrs:{"to":{ name: 'PaxelRecycleWasteType' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Waste Type")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleBeforeSending',
              },attrs:{"to":{ name: 'PaxelRecycleBeforeSending' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Before Sending")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': 
                _vm.routename === 'PaxelRecycleHowTo' ||
                _vm.routename === 'createPaxelRecycleHowTo' ||
                _vm.routename === 'editPaxelRecycleHowTo',
              },attrs:{"to":{ name: 'PaxelRecycleHowTo' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("How Tos")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleTutorial'
              },attrs:{"to":{ name: 'PaxelRecycleTutorial' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Tutorial Video")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleCoverage'
              },attrs:{"to":{ name: 'PaxelRecycleCoverage' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Coverage")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelRecycleMoreInfo'
              },attrs:{"to":{ name: 'PaxelRecycleMoreInfo' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("More Info")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'BigBanner' ||
                  _vm.routename === 'FlowBig' ||
                  _vm.routename === 'BigCustomerList' ||
                  _vm.routename === 'createBigCustomerList' ||
                  _vm.routename === 'editBigCustomerList' ||
                  _vm.routename === 'BigExcellence' ||
                  _vm.routename === 'createBigExcellence' ||
                  _vm.routename === 'editBigExcellence' ||
                  _vm.routename === 'BigRegistrationButton',
              },attrs:{"data-toggle":"collapse","href":"#PaxelBigCollapse","aria-expanded":"true","aria-controls":"PaxelBigCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'BigBanner' &&
                    _vm.routename != 'FlowBig' &&
                    _vm.routename != 'BigCustomerList' &&
                    _vm.routename != 'createBigCustomerList' &&
                    _vm.routename != 'editBigCustomerList' &&
                    _vm.routename != 'BigExcellence' &&
                    _vm.routename != 'createBigExcellence' &&
                    _vm.routename != 'editBigExcellence' &&
                    _vm.routename != 'BigRegistrationButton',
                }},[_vm._v("Paxel Big")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'BigBanner' ||
                _vm.routename === 'FlowBig' ||
                _vm.routename === 'BigCustomerList' ||
                _vm.routename === 'createBigCustomerList' ||
                _vm.routename === 'editBigCustomerList' ||
                _vm.routename === 'BigExcellence' ||
                _vm.routename === 'createBigExcellence' ||
                _vm.routename === 'editBigExcellence' ||
                _vm.routename === 'BigRegistrationButton',
            },attrs:{"id":"PaxelBigCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'BigBanner',
              },attrs:{"to":{ name: 'BigBanner' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'FlowBig',
              },attrs:{"to":{ name: 'FlowBig' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Flow")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'BigCustomerList' ||
                  _vm.routename === 'createBigCustomerList' ||
                  _vm.routename === 'editBigCustomerList',
              },attrs:{"to":{ name: 'BigCustomerList' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Customer List")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'BigExcellence' ||
                  _vm.routename === 'createBigExcellence' ||
                  _vm.routename === 'editBigExcellence',
              },attrs:{"to":{ name: 'BigExcellence' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Keunggulan")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'BigRegistrationButton',
              },attrs:{"to":{ name: 'BigRegistrationButton' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Registration Button")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'PaxelMarketMainHeader' ||
                  _vm.routename === 'PaxelMarketMeta' ||
                  _vm.routename === 'PaxelMarketBasicService' ||
                  _vm.routename === 'createPaxelMarketBasicService' ||
                  _vm.routename === 'editPaxelMarketBasicService' ||
                  _vm.routename === 'PaxelMarketMainFeatures' ||
                  _vm.routename === 'createPaxelMarketMainFeatures' ||
                  _vm.routename === 'editPaxelMarketMainFeatures' ||
                  _vm.routename === 'PaxelMarketJoinProcedure' ||
                  _vm.routename === 'createPaxelMarketJoinProcedure' ||
                  _vm.routename === 'editPaxelMarketJoinProcedure' ||
                  _vm.routename === 'PaxelMarketSOP' ||
          _vm.routename === 'createPaxelMarketSOP' ||
          _vm.routename === 'editPaxelMarketSOP' ||
                  _vm.routename === 'PaxelMarketPartners' ||
                  _vm.routename === 'createPaxelMarketPartners' ||
                  _vm.routename === 'editPaxelMarketPartners',
              },attrs:{"data-toggle":"collapse","href":"#PaxelMarketCollapse","aria-expanded":"true","aria-controls":"PaxelMarketCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'PaxelMarketMainHeader' &&
                    _vm.routename != 'PaxelMarketMeta' &&
                    _vm.routename != 'PaxelMarketBasicService' &&
                    _vm.routename != 'createPaxelMarketBasicService' &&
                    _vm.routename != 'editPaxelMarketBasicService' &&
                    _vm.routename != 'PaxelMarketMainFeatures' &&
                    _vm.routename != 'createPaxelMarketMainFeatures' &&
                    _vm.routename != 'editPaxelMarketMainFeatures' &&
                    _vm.routename != 'PaxelMarketJoinProcedure' &&
                    _vm.routename != 'createPaxelMarketJoinProcedure' &&
                    _vm.routename != 'editPaxelMarketJoinProcedure' &&
                    _vm.routename != 'PaxelMarketSOP' &&
            _vm.routename != 'createPaxelMarketSOP' &&
            _vm.routename != 'editPaxelMarketSOP' &&
                    _vm.routename != 'PaxelMarketPartners',
                }},[_vm._v("Paxel Market")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'PaxelMarketMainHeader' ||
                _vm.routename === 'PaxelMarketMeta' ||
                _vm.routename === 'PaxelMarketBasicService' ||
                _vm.routename === 'createPaxelMarketBasicService' ||
                _vm.routename === 'editPaxelMarketBasicService' ||
                _vm.routename === 'PaxelMarketMainFeatures' ||
                _vm.routename === 'createPaxelMarketMainFeatures' ||
                _vm.routename === 'editPaxelMarketMainFeatures' ||
                _vm.routename === 'PaxelMarketJoinProcedure' ||
                _vm.routename === 'createPaxelMarketJoinProcedure' ||
                _vm.routename === 'editPaxelMarketJoinProcedure' ||
                _vm.routename === 'PaxelMarketSOP' ||
          _vm.routename === 'createPaxelMarketSOP' ||
          _vm.routename === 'editPaxelMarketSOP' ||
                _vm.routename === 'PaxelMarketPartners' ||
                _vm.routename === 'createPaxelMarketPartners' ||
                _vm.routename === 'editPaxelMarketPartners',
            },attrs:{"id":"PaxelMarketCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelMarketMainHeader',
              },attrs:{"to":{ name: 'PaxelMarketMainHeader' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Main Header")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PaxelMarketMeta',
              },attrs:{"to":{ name: 'PaxelMarketMeta' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Meta")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelMarketBasicService' ||
                  _vm.routename === 'createPaxelMarketBasicService' ||
                  _vm.routename === 'editPaxelMarketBasicService',
              },attrs:{"to":{ name: 'PaxelMarketBasicService' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Basic Service")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelMarketMainFeatures' ||
                  _vm.routename === 'createPaxelMarketMainFeatures' ||
                  _vm.routename === 'editPaxelMarketMainFeatures',
              },attrs:{"to":{ name: 'PaxelMarketMainFeatures' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Main Features")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelMarketJoinProcedure' ||
                  _vm.routename === 'createPaxelMarketJoinProcedure' ||
                  _vm.routename === 'editPaxelMarketJoinProcedure',
              },attrs:{"to":{ name: 'PaxelMarketJoinProcedure' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Join Procedure")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelMarketSOP' ||
                  _vm.routename === 'createPaxelMarketSOP' ||
                  _vm.routename === 'editPaxelMarketSOP',
              },attrs:{"to":{ name: 'PaxelMarketSOP' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("SOP")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'PaxelMarketPartners' ||
                  _vm.routename === 'createPaxelMarketPartners' ||
                  _vm.routename === 'editPaxelMarketPartners',
              },attrs:{"to":{ name: 'PaxelMarketPartners' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Paxel Market Partners")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'customerList' ||
                  _vm.routename === 'detailCustomer' ||
                  _vm.routename === 'bannerMitraPaxel',
              },attrs:{"data-toggle":"collapse","href":"#MitraPaxelCollapse","aria-expanded":"true","aria-controls":"MitraPaxelCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'customerList' &&
                    _vm.routename != 'detailCustomer' &&
                    _vm.routename != 'bannerMitraPaxel',
                }},[_vm._v("Mitra PaxelCo")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'customerList' ||
                _vm.routename === 'detailCustomer' ||
                _vm.routename === 'bannerMitraPaxel',
            },attrs:{"id":"MitraPaxelCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'bannerMitraPaxel',
              },attrs:{"to":{ name: 'bannerMitraPaxel' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'customerList' ||
                  _vm.routename === 'detailCustomer',
              },attrs:{"to":{ name: 'customerList' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Customer List")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'FaqCategory' ||
                  _vm.routename === 'FaqContent' ||
                  _vm.routename === 'createFaq' ||
                  _vm.routename === 'editFaq' ||
                  _vm.routename === 'createFaqCategory' ||
                  _vm.routename === 'editFaqCategory',
              },attrs:{"data-toggle":"collapse","href":"#FaqCollapse","aria-expanded":"true","aria-controls":"FaqCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'FaqCategory' &&
                    _vm.routename != 'FaqContent' &&
                    _vm.routename != 'createFaq' &&
                    _vm.routename != 'editFaq' &&
                    _vm.routename != 'createFaqCategory' &&
                    _vm.routename != 'editFaqCategory',
                }},[_vm._v("Bantuan & FAQ")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'FaqCategory' ||
                _vm.routename === 'FaqContent' ||
                _vm.routename === 'createFaq' ||
                _vm.routename === 'editFaq' ||
                _vm.routename === 'createFaqCategory' ||
                _vm.routename === 'editFaqCategory',
            },attrs:{"id":"FaqCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'FaqCategory' ||
                  _vm.routename === 'createFaqCategory' ||
                  _vm.routename === 'editFaqCategory',
              },attrs:{"to":{ name: 'FaqCategory' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("FAQ Category")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'FaqContent' ||
                  _vm.routename === 'createFaq' ||
                  _vm.routename === 'editFaq',
              },attrs:{"to":{ name: 'FaqContent' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("FAQ Content")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'CorpSalesExcellence' ||
                  _vm.routename === 'CorpSalesTestimonial' ||
                  _vm.routename === 'createCorpSalesExcellence' ||
                  _vm.routename === 'editCorpSalesExcellence' ||
                  _vm.routename === 'createCorpSalesTestimonial' ||
                  _vm.routename === 'editCorpSalesTestimonial' ||
                  _vm.routename === 'bannerCorpSales' ||
                  _vm.routename === 'createCorpPartnerList' ||
                  _vm.routename === 'editCorpPartnerList' ||
                  _vm.routename === 'CorpPartnerList',
              },attrs:{"data-toggle":"collapse","href":"#PartnershipColapse","aria-expanded":"true","aria-controls":"PartnershipColapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'CorpSalesExcellence' &&
                    _vm.routename != 'CorpSalesTestimonial' &&
                    _vm.routename != 'createCorpSalesExcellence' &&
                    _vm.routename != 'editCorpSalesExcellence' &&
                    _vm.routename != 'createCorpSalesTestimonial' &&
                    _vm.routename != 'editCorpSalesTestimonial' &&
                    _vm.routename != 'bannerCorpSales' &&
                    _vm.routename != 'createCorpPartnerList' &&
                    _vm.routename != 'editCorpPartnerList' &&
                    _vm.routename != 'CorpPartnerList',
                }},[_vm._v("\n                Corporate Sales  \n                "),_c('b',{staticClass:"caret"})])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'CorpSalesExcellence' ||
                _vm.routename === 'createCorpSalesExcellence' ||
                _vm.routename === 'editCorpSalesExcellence' ||
                _vm.routename === 'CorpSalesTestimonial' ||
                _vm.routename === 'createCorpSalesTestimonial' ||
                _vm.routename === 'editCorpSalesTestimonial' ||
                _vm.routename === 'bannerCorpSales' ||
                _vm.routename === 'createCorpPartnerList' ||
                _vm.routename === 'editCorpPartnerList' ||
                _vm.routename === 'CorpPartnerList',
            },attrs:{"id":"PartnershipColapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'bannerCorpSales',
              },attrs:{"to":{ name: 'bannerCorpSales' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'CorpSalesExcellence' ||
                  _vm.routename === 'createCorpSalesExcellence' ||
                  _vm.routename === 'editCorpSalesExcellence',
              },attrs:{"to":{ name: 'CorpSalesExcellence' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Keunggulan")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'createCorpSalesTestimonial' ||
                  _vm.routename === 'editCorpSalesTestimonial' ||
                  _vm.routename === 'CorpSalesTestimonial',
              },attrs:{"to":{ name: 'CorpSalesTestimonial' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Testimonial")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'createCorpPartnerList' ||
                  _vm.routename === 'editCorpPartnerList' ||
                  _vm.routename === 'CorpPartnerList',
              },attrs:{"to":{ name: 'CorpPartnerList' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Daftar Partner")])])],1),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Privacypolicy' ||
                _vm.routename === 'editPrivacypolicy' ||
                _vm.routename === 'createPrivacypolicy',
            },attrs:{"to":{ name: 'Privacypolicy' }}},[_vm._v("Kebijakan Privasi")]),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'TncContent' ||
                  _vm.routename === 'createTncContent' ||
                  _vm.routename === 'editTncContent' ||
                  _vm.routename === 'TncCategory' ||
                  _vm.routename === 'createTncCategory' ||
                  _vm.routename === 'editTncCategory',
              },attrs:{"data-toggle":"collapse","href":"#TncColapse","aria-expanded":"true","aria-controls":"TncColapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'TncContent' &&
                    _vm.routename != 'createTncContent' &&
                    _vm.routename != 'editTncContent' &&
                    _vm.routename != 'TncCategory' &&
                    _vm.routename != 'createTncCategory' &&
                    _vm.routename != 'editTncCategory',
                }},[_vm._v("Syarat&Ketentuan")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'TncContent' ||
                _vm.routename === 'createTncContent' ||
                _vm.routename === 'editTncContent' ||
                _vm.routename === 'TncCategory' ||
                _vm.routename === 'createTncCategory' ||
                _vm.routename === 'editTncCategory',
            },attrs:{"id":"TncColapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'TncCategory' ||
                  _vm.routename === 'createTncCategory' ||
                  _vm.routename === 'editTncCategory',
              },attrs:{"to":{ name: 'TncCategory' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("S&K Category")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'TncContent' ||
                  _vm.routename === 'createTncContent' ||
                  _vm.routename === 'editTncContent',
              },attrs:{"to":{ name: 'TncContent' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("S&K Content")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'bannerLocker' ||
                  _vm.routename === 'createBannerLocker' ||
                  _vm.routename === 'editBannerLocker' ||
                  _vm.routename === 'servicesLocker' ||
                  _vm.routename === 'createServicesLocker' ||
                  _vm.routename === 'editGuestBook' ||
                  _vm.routename === 'editServicesLocker',
              },attrs:{"data-toggle":"collapse","href":"#MicrositeCollapse","aria-expanded":"true","aria-controls":"MicrositeCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'bannerLocker' &&
                    _vm.routename != 'createBannerLocker' &&
                    _vm.routename != 'editBannerLocker' &&
                    _vm.routename != 'servicesLocker' &&
                    _vm.routename != 'createServicesLocker' &&
                    _vm.routename != 'editGuestBook' &&
                    _vm.routename != 'editServicesLocker',
                }},[_vm._v("Locker Microsite")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'bannerLocker' ||
                _vm.routename === 'createBannerLocker' ||
                _vm.routename === 'editBannerLocker' ||
                _vm.routename === 'servicesLocker' ||
                _vm.routename === 'createServicesLocker' ||
                _vm.routename === 'editGuestBook' ||
                _vm.routename === 'editServicesLocker',
            },attrs:{"id":"MicrositeCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'bannerLocker' ||
                  _vm.routename === 'createBannerLocker' ||
                  _vm.routename === 'editBannerLocker',
              },attrs:{"to":{ name: 'bannerLocker' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner Microsite")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'servicesLocker' ||
                  _vm.routename === 'createServicesLocker' ||
                  _vm.routename === 'editServicesLocker',
              },attrs:{"to":{ name: 'servicesLocker' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("PaxelBox Services")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'editGuestBook',
              },attrs:{"to":{ name: 'editGuestBook' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Guest Book")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'editBannerDownload',
              },attrs:{"data-toggle":"collapse","href":"#DownloadCollapse","aria-expanded":"true","aria-controls":"DownloadCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'editBannerDownload',
                }},[_vm._v("Download Page")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'editBannerDownload',
            },attrs:{"id":"DownloadCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'editBannerDownload',
              },attrs:{"to":{ name: 'editBannerDownload' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'PejuangOnlineBanner',
              },attrs:{"data-toggle":"collapse","href":"#PejuangOnlineCollapse","aria-expanded":"true","aria-controls":"PejuangOnlineCollapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'PejuangOnlineBanner',
                }},[_vm._v("Pejuang Online")])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'PejuangOnlineBanner',
            },attrs:{"id":"PejuangOnlineCollapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'PejuangOnlineBanner',
              },attrs:{"to":{ name: 'PejuangOnlineBanner' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Banner")])])],1),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'GlobalSearch' ||
                  _vm.routename === 'createGlobalSearch' ||
                  _vm.routename === 'editGlobalSearch',
            },attrs:{"to":{ name: 'GlobalSearch' }}},[_vm._v("Global Search")])],1)])]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'GeneralEnableDisableFeature' ||
          _vm.routename === 'createGeneralEnableDisableFeature' ||
          _vm.routename === 'editGeneralEnableDisableFeature' ||
          _vm.routename === 'GeneralContactUs' ||
          _vm.routename === 'createGeneralContactUs' ||
          _vm.routename === 'editGeneralContactUs' ||
          _vm.routename === 'GeneralNewUserPromo' ||
          _vm.routename === 'createGeneralNewUserPromo' ||
          _vm.routename === 'editGeneralNewUserPromo' ||
          _vm.routename === 'GeneralSettings' ||
          _vm.routename === 'ReportRefferal' ||
          _vm.routename === 'ReportRating' ||
          _vm.routename === 'Rate' ||
          _vm.routename === 'createRate' ||
          _vm.routename === 'editRate' ||
          _vm.routename === 'Reason' ||
          _vm.routename === 'createReason' ||
          _vm.routename === 'editReason' ||
          _vm.routename === 'ExtraPackaging' ||
          _vm.routename === 'createExtraPackaging' ||
          _vm.routename === 'editExtraPackaging' ||
          _vm.routename === 'Donasi' ||
          _vm.routename === 'createDonasi' ||
          _vm.routename === 'editDonasi' ||
          _vm.routename === 'ShowCase' ||
          _vm.routename === 'createShowCase' ||
          _vm.routename === 'editShowCase' ||
          _vm.routename === 'newUserPromo' ||
          _vm.routename === 'createnewUserPromo' ||
          _vm.routename === 'editnewUserPromo' ||
          _vm.routename === 'onBoardingScreen' ||
          _vm.routename === 'createonBoardingScreen' ||
          _vm.routename === 'editonBoardingScreen' ||
          _vm.routename === 'Click2buy' ||
          _vm.routename === 'formClick2buy' ||
          _vm.routename === 'refferalPartner' ||
          _vm.routename === 'createrefferalPartner' ||
          _vm.routename === 'editrefferalPartner',
      },on:{"mouseover":function($event){_vm.userapp = true},"mouseleave":function($event){_vm.userapp = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapseUserapp","aria-expanded":"true","aria-controls":"collapseUserapp"}},[(
            _vm.userapp ||
            _vm.routename === 'GeneralEnableDisableFeature' ||
            _vm.routename === 'createGeneralEnableDisableFeature' ||
            _vm.routename === 'editGeneralEnableDisableFeature' ||
            _vm.routename === 'GeneralContactUs' ||
            _vm.routename === 'createGeneralContactUs' ||
            _vm.routename === 'editGeneralContactUs' ||
            _vm.routename === 'GeneralNewUserPromo' ||
            _vm.routename === 'createGeneralNewUserPromo' ||
            _vm.routename === 'editGeneralNewUserPromo' ||
            _vm.routename === 'GeneralSettings' ||
            _vm.routename === 'ReportRefferal' ||
            _vm.routename === 'ReportRating' ||
            _vm.routename === 'Rate' ||
            _vm.routename === 'createRate' ||
            _vm.routename === 'editRate' ||
            _vm.routename === 'Reason' ||
            _vm.routename === 'createReason' ||
            _vm.routename === 'editReason' ||
            _vm.routename === 'ExtraPackaging' ||
            _vm.routename === 'createExtraPackaging' ||
            _vm.routename === 'editExtraPackaging' ||
            _vm.routename === 'Donasi' ||
            _vm.routename === 'createDonasi' ||
            _vm.routename === 'editDonasi' ||
            _vm.routename === 'ShowCase' ||
            _vm.routename === 'createShowCase' ||
            _vm.routename === 'editShowCase' ||
            _vm.routename === 'newUserPromo' ||
            _vm.routename === 'createnewUserPromo' ||
            _vm.routename === 'editnewUserPromo' ||
            _vm.routename === 'onBoardingScreen' ||
            _vm.routename === 'createonBoardingScreen' ||
            _vm.routename === 'editonBoardingScreen' ||
            _vm.routename === 'Click2buy' ||
            _vm.routename === 'formClick2buy' ||
            _vm.routename === 'refferalPartner' ||
            _vm.routename === 'createrefferalPartner' ||
            _vm.routename === 'editrefferalPartner'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-phone-mobile.svg"),"alt":""}}):(
            _vm.routename != 'GeneralEnableDisableFeature' &&
            _vm.routename != 'createGeneralEnableDisableFeature' &&
            _vm.routename != 'editGeneralEnableDisableFeature' &&
            _vm.routename != 'GeneralContactUs' &&
            _vm.routename != 'createGeneralContactUs' &&
            _vm.routename != 'editGeneralContactUs' &&
            _vm.routename != 'GeneralNewUserPromo' &&
            _vm.routename != 'createGeneralNewUserPromo' &&
            _vm.routename != 'editGeneralNewUserPromo' &&
            _vm.routename != 'GeneralSettings' &&
            _vm.routename != 'ReportRefferal' &&
            _vm.routename != 'ReportRating' &&
            _vm.routename != 'Rate' &&
            _vm.routename != 'createRate' &&
            _vm.routename != 'editRate' &&
            _vm.routename != 'Reason' &&
            _vm.routename != 'createReason' &&
            _vm.routename != 'editReason' &&
            _vm.routename != 'ExtraPackaging' &&
            _vm.routename != 'createExtraPackaging' &&
            _vm.routename != 'editExtraPackaging' &&
            _vm.routename != 'Donasi' &&
            _vm.routename != 'createDonasi' &&
            _vm.routename != 'editDonasi' &&
            _vm.routename != 'newUserPromo' &&
            _vm.routename != 'ShowCase' &&
            _vm.routename != 'createShowCase' &&
            _vm.routename != 'editShowCase' &&
            _vm.routename != 'createnewUserPromo' &&
            _vm.routename != 'editnewUserPromo' &&
            _vm.routename != 'onBoardingScreen' &&
            _vm.routename != 'createonBoardingScreen' &&
            _vm.routename != 'editonBoardingScreen' &&
            _vm.routename != 'Click2buy' &&
            _vm.routename != 'formClick2buy' &&
            _vm.routename != 'refferalPartner' &&
            _vm.routename != 'createrefferalPartner' &&
            _vm.routename != 'editrefferalPartner' &&
            !_vm.userapp
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-phone-mobile-inactive.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("User App Setting")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'GeneralEnableDisableFeature' ||
            _vm.routename === 'createGeneralEnableDisableFeature' ||
            _vm.routename === 'editGeneralEnableDisableFeature' ||
            _vm.routename === 'GeneralContactUs' ||
            _vm.routename === 'createGeneralContactUs' ||
            _vm.routename === 'editGeneralContactUs' ||
            _vm.routename === 'GeneralNewUserPromo' ||
            _vm.routename === 'createGeneralNewUserPromo' ||
            _vm.routename === 'editGeneralNewUserPromo' ||
            _vm.routename === 'GeneralSettings' ||
            _vm.routename === 'ReportRefferal' ||
            _vm.routename === 'ReportRating' ||
            _vm.routename === 'Rate' ||
            _vm.routename === 'createRate' ||
            _vm.routename === 'editRate' ||
            _vm.routename === 'Reason' ||
            _vm.routename === 'createReason' ||
            _vm.routename === 'editReason' ||
            _vm.routename === 'ExtraPackaging' ||
            _vm.routename === 'createExtraPackaging' ||
            _vm.routename === 'editExtraPackaging' ||
            _vm.routename === 'Donasi' ||
            _vm.routename === 'createDonasi' ||
            _vm.routename === 'editDonasi' ||
            _vm.routename === 'ShowCase' ||
            _vm.routename === 'createShowCase' ||
            _vm.routename === 'editShowCase' ||
            _vm.routename === 'newUserPromo' ||
            _vm.routename === 'createnewUserPromo' ||
            _vm.routename === 'editnewUserPromo' ||
            _vm.routename === 'onBoardingScreen' ||
            _vm.routename === 'createonBoardingScreen' ||
            _vm.routename === 'editonBoardingScreen' ||
            _vm.routename === 'Click2buy' ||
            _vm.routename === 'formClick2buy' ||
            _vm.routename === 'refferalPartner' ||
            _vm.routename === 'createrefferalPartner' ||
            _vm.routename === 'editrefferalPartner',
        },attrs:{"id":"collapseUserapp","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Donasi' ||
                _vm.routename === 'createDonasi' ||
                _vm.routename === 'editDonasi',
            },attrs:{"to":{ name: 'Donasi' }}},[_vm._v("Donasi")]),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'Rate' ||
                  _vm.routename === 'Reason' ||
                  _vm.routename === 'ReportRating' ||
                  _vm.routename === 'createRate' ||
                  _vm.routename === 'editRate',
              },attrs:{"data-toggle":"collapse","href":"#RateColapse","aria-expanded":"true","aria-controls":"RateColapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'Rate' &&
                    _vm.routename != 'Reason' &&
                    _vm.routename != 'ReportRating' &&
                    _vm.routename != 'createRate' &&
                    _vm.routename != 'editRate',
                }},[_vm._v("\n                Rating  \n                "),_c('b',{staticClass:"caret"})])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'Rate' ||
                _vm.routename === 'Reason' ||
                _vm.routename === 'createRate' ||
                _vm.routename === 'editRate' ||
                _vm.routename === 'createReason' ||
                _vm.routename === 'editReason' ||
                _vm.routename === 'ReportRating',
            },attrs:{"id":"RateColapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'Rate' ||
                  _vm.routename === 'createRate' ||
                  _vm.routename === 'editRate',
              },attrs:{"to":{ name: 'Rate' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Rate")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'Reason' ||
                  _vm.routename === 'createReason' ||
                  _vm.routename === 'editReason',
              },attrs:{"to":{ name: 'Reason' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Reason")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'ReportRating',
              },attrs:{"to":{ name: 'ReportRating' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Report")])])],1),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Click2buy' ||
                _vm.routename === 'formClick2buy',
            },attrs:{"to":{ name: 'Click2buy' }}},[_vm._v("Click2Buy")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'onBoardingScreen' ||
                _vm.routename === 'createonBoardingScreen' ||
                _vm.routename === 'editonBoardingScreen',
            },attrs:{"to":{ name: 'onBoardingScreen' }}},[_vm._v("On Boarding Screen")]),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'refferalPartner' ||
                  _vm.routename === 'ReportRefferal' ||
                  _vm.routename === 'createrefferalPartner' ||
                  _vm.routename === 'editrefferalPartner',
              },attrs:{"data-toggle":"collapse","href":"#RefferalColapse","aria-expanded":"true","aria-controls":"RefferalColapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'refferalPartner' &&
                    _vm.routename != 'ReportRefferal' &&
                    _vm.routename != 'createrefferalPartner' &&
                    _vm.routename != 'editrefferalPartner',
                }},[_vm._v("\n                Refferal  \n                "),_c('b',{staticClass:"caret"})])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'refferalPartner' ||
                _vm.routename === 'ReportRefferal' ||
                _vm.routename === 'createrefferalPartner' ||
                _vm.routename === 'editrefferalPartner',
            },attrs:{"id":"RefferalColapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'refferalPartner' ||
                  _vm.routename === 'createrefferalPartner' ||
                  _vm.routename === 'editrefferalPartner',
              },attrs:{"to":{ name: 'refferalPartner' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Partner")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active': _vm.routename === 'ReportRefferal',
              },attrs:{"to":{ name: 'ReportRefferal' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Report")])])],1),_c('li',{staticClass:"pl-1"},[_c('a',{staticClass:"nav-link collapsed pl-5",class:{
                'active border-right-active-dropdown':
                  _vm.routename === 'GeneralEnableDisableFeature' ||
                  _vm.routename === 'createGeneralEnableDisableFeature' ||
                  _vm.routename === 'editGeneralEnableDisableFeature' ||
                  _vm.routename === 'GeneralContactUs' ||
                  _vm.routename === 'GeneralNewUserPromo' ||
                  _vm.routename === 'createGeneralContactUs' ||
                  _vm.routename === 'editGeneralContactUs' ||
                  _vm.routename === 'createGeneralNewUserPromo' ||
                  _vm.routename === 'editGeneralNewUserPromo',
              },attrs:{"data-toggle":"collapse","href":"#GeneralSettingsColapse","aria-expanded":"true","aria-controls":"GeneralSettingsColapse"}},[_c('span',{staticClass:"sidebar-normal pl-3",class:{
                  'font-weight-normal secondsub-sidebar':
                    _vm.routename != 'GeneralEnableDisableFeature' &&
                    _vm.routename != 'createGeneralEnableDisableFeature' &&
                    _vm.routename != 'editGeneralEnableDisableFeature' &&
                    _vm.routename != 'GeneralContactUs' &&
                    _vm.routename != 'GeneralNewUserPromo' &&
                    _vm.routename != 'createGeneralContactUs' &&
                    _vm.routename != 'editGeneralContactUs' &&
                    _vm.routename != 'createGeneralNewUserPromo' &&
                    _vm.routename != 'editGeneralNewUserPromo',
                }},[_vm._v("\n                General Settings  \n                "),_c('b',{staticClass:"caret"})])])]),_c('div',{staticClass:"collapse m-0",class:{
              show:
                _vm.routename === 'GeneralEnableDisableFeature' ||
                _vm.routename === 'createGeneralEnableDisableFeature' ||
                _vm.routename === 'editGeneralEnableDisableFeature' ||
                _vm.routename === 'GeneralContactUs' ||
                _vm.routename === 'createGeneralContactUs' ||
                _vm.routename === 'editGeneralContactUs' ||
                _vm.routename === 'GeneralNewUserPromo' ||
                _vm.routename === 'createGeneralNewUserPromo' ||
                _vm.routename === 'editGeneralNewUserPromo',
            },attrs:{"id":"GeneralSettingsColapse"}},[_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'GeneralContactUs' ||
                  _vm.routename === 'createGeneralContactUs' ||
                  _vm.routename === 'editGeneralContactUs',
              },attrs:{"to":{ name: 'GeneralContactUs' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Contact Us")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'GeneralEnableDisableFeature' ||
                  _vm.routename === 'createGeneralEnableDisableFeature' ||
                  _vm.routename === 'editGeneralEnableDisableFeature',
              },attrs:{"to":{ name: 'GeneralEnableDisableFeature' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("Feature ON/OFF")])]),_c('router-link',{staticClass:"collapse-item",class:{
                'active border-right-active':
                  _vm.routename === 'createGeneralNewUserPromo' ||
                  _vm.routename === 'editGeneralNewUserPromo' ||
                  _vm.routename === 'GeneralNewUserPromo',
              },attrs:{"to":{ name: 'GeneralNewUserPromo' }}},[_c('span',{staticClass:"sidebar-normal pl-4"},[_vm._v("New User Promo")])])],1)],1)])]),_c('li',{staticClass:"nav-item",class:{
        'active border-right-active-dropdown':
          _vm.routename === 'Members' ||
          _vm.routename === 'Event' ||
          _vm.routename === 'createEvent' ||
          _vm.routename === 'editEvent'||
          _vm.routename === 'PointSales' ||
          _vm.routename === 'createPointSales' ||
          _vm.routename === 'editPointSales'||
          _vm.routename === 'VoucerService' ||
          _vm.routename === 'createVoucerService' ||
          _vm.routename === 'editVoucerService'||
          _vm.routename === 'ClaimedBenefit'||
          _vm.routename === 'createClaimedBenefit'||
          _vm.routename === 'editClaimedBenefit'||
          _vm.routename === 'BenefitCategory'||
          _vm.routename === 'createBenefitCategory'||
          _vm.routename === 'editBenefitCategory'||
          _vm.routename === 'BenefitType'||
          _vm.routename === 'createBenefitType'||
          _vm.routename === 'editBenefitType'||
          _vm.routename === 'Benefit'||
          _vm.routename === 'createBenefit'||
          _vm.routename === 'editBenefit',
      },on:{"mouseover":function($event){_vm.paxelin_club = true},"mouseleave":function($event){_vm.paxelin_club = false}}},[_c('a',{staticClass:"nav-link collapsed",attrs:{"href":"#","data-toggle":"collapse","data-target":"#collapsePaxelinClub","aria-expanded":"true","aria-controls":"collapsePaxelinClub"}},[(
            _vm.paxelin_club ||
            _vm.routename === 'Members' ||
            _vm.routename === 'Event' ||
            _vm.routename === 'createEvent' ||
            _vm.routename === 'editEvent'||
            _vm.routename === 'PointSales' ||
            _vm.routename === 'createPointSales' ||
            _vm.routename === 'editPointSales'||
            _vm.routename === 'VoucerService' ||
            _vm.routename === 'createVoucerService' ||
            _vm.routename === 'editVoucerService'||
            _vm.routename === 'ClaimedBenefit'||
            _vm.routename === 'createClaimedBenefit'||
            _vm.routename === 'editClaimedBenefit'||
            _vm.routename === 'BenefitCategory'||
            _vm.routename === 'createBenefitCategory'||
            _vm.routename === 'editBenefitCategory'||
            _vm.routename === 'BenefitType'||
            _vm.routename === 'createBenefitType'||
            _vm.routename === 'editBenefitType'||
            _vm.routename === 'Benefit'||
            _vm.routename === 'createBenefit'||
            _vm.routename === 'editBenefit'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-favorite.svg"),"alt":""}}):(
            _vm.routename != 'Members' &&
            _vm.routename != 'Event' &&
            _vm.routename != 'createEvent' &&
            _vm.routename != 'editEvent' &&
            _vm.routename != 'PointSales' &&
            _vm.routename != 'createPointSales' &&
            _vm.routename != 'editPointSales' &&
            _vm.routename != 'VoucerService' &&
            _vm.routename != 'createVoucerService' &&
            _vm.routename != 'editVoucerService' &&
            _vm.routename != 'ClaimedBenefit' &&
            _vm.routename != 'createClaimedBenefit' &&
            _vm.routename != 'editClaimedBenefit' &&
            _vm.routename != 'BenefitCategory' &&
            _vm.routename != 'createBenefitCategory' &&
            _vm.routename != 'editBenefitCategory' &&
            _vm.routename != 'BenefitType' &&
            _vm.routename != 'createBenefitType' &&
            _vm.routename != 'editBenefitType' &&
            _vm.routename != 'Benefit' &&
            _vm.routename != 'createBenefit' &&
            _vm.routename != 'editBenefit' &&
            !_vm.paxelin_club
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-favorite-bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Paxelin Club")])]),_c('div',{staticClass:"collapse",class:{
          show:
            _vm.routename === 'Members' ||
            _vm.routename === 'Event' ||
            _vm.routename === 'createEvent' ||
            _vm.routename === 'editEvent'||
            _vm.routename === 'PointSales' ||
            _vm.routename === 'createPointSales' ||
            _vm.routename === 'editPointSales'||
            _vm.routename === 'VoucerService' ||
            _vm.routename === 'createVoucerService' ||
            _vm.routename === 'editVoucerService'||
            _vm.routename === 'ClaimedBenefit'||
            _vm.routename === 'createClaimedBenefit'||
            _vm.routename === 'editClaimedBenefit' ||
            _vm.routename === 'BenefitCategory'||
            _vm.routename === 'createBenefitCategory'||
            _vm.routename === 'editBenefitCategory'||
            _vm.routename === 'BenefitType'||
            _vm.routename === 'createBenefitType'||
            _vm.routename === 'editBenefitType'||
            _vm.routename === 'Benefit'||
            _vm.routename === 'createBenefit'||
            _vm.routename === 'editBenefit',
        },attrs:{"id":"collapsePaxelinClub","aria-labelledby":"headingPages","data-parent":"#accordionSidebar"}},[_c('div',{staticClass:"bg-white collapse-inner text-left"},[_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Members',
            },attrs:{"to":{ name: 'Members' }}},[_vm._v("Members")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'BenefitCategory' ||
                _vm.routename === 'createBenefitCategory' ||
                _vm.routename === 'editBenefitCategory',
            },attrs:{"to":{ name: 'BenefitCategory' }}},[_vm._v("Master Benefit Category")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'BenefitType' ||
                _vm.routename === 'createBenefitType' ||
                _vm.routename === 'editBenefitType',
            },attrs:{"to":{ name: 'BenefitType' }}},[_vm._v("Master Benefit Type")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'Benefit' ||
                _vm.routename === 'createBenefit' ||
                _vm.routename === 'editBenefit',
            },attrs:{"to":{ name: 'Benefit' }}},[_vm._v("Benefit")]),_c('router-link',{staticClass:"collapse-item",class:{
              'active border-right-active':
                _vm.routename === 'ClaimedBenefit' ||
                _vm.routename === 'createClaimedBenefit' ||
                _vm.routename === 'editClaimedBenefit',
            },attrs:{"to":{ name: 'ClaimedBenefit' }}},[_vm._v("Claimed Benefit")])],1)])])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(
      _vm.session.role == 'developer' ||
      _vm.session.role == 'superadmin'
    ),expression:"\n      session.role == 'developer' ||\n      session.role == 'superadmin'\n    "}]},[_c('hr',{staticClass:"sidebar-divider"}),_c('div',{staticClass:"sidebar-heading"},[_vm._v("Developer")]),_c('li',{staticClass:"nav-item text-nowrap",class:{
        'active border-right-active':
          _vm.routename === 'ErrorLog',
      },on:{"mouseover":function($event){_vm.developer_error_log = true},"mouseleave":function($event){_vm.developer_error_log = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'ErrorLog' }}},[(
            _vm.developer_error_log ||
            _vm.routename === 'ErrorLog'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'ErrorLog' &&
            !_vm.developer_error_log
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Shipment Log")])])],1),_c('li',{directives:[{name:"show",rawName:"v-show",value:(
        _vm.session.role == 'developer' ||
        _vm.session.role == 'superadmin'
      ),expression:"\n        session.role == 'developer' ||\n        session.role == 'superadmin'\n      "}],staticClass:"nav-item",class:{
        'active border-right-active':
          _vm.routename === 'GuideBook' ||
          _vm.routename === 'createGuideBook' ||
          _vm.routename === 'editGuideBook'
      },on:{"mouseover":function($event){_vm.developer_guide_book = true},"mouseleave":function($event){_vm.developer_guide_book = false}}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":{ name: 'GuideBook' }}},[(
            _vm.developer_guide_book ||
            _vm.routename === 'GuideBook' ||
            _vm.routename === 'createGuideBook' ||
            _vm.routename === 'editGuideBook'
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_color.svg"),"alt":""}}):(
            _vm.routename != 'GuideBook' &&
            _vm.routename != 'createGuideBook' &&
            _vm.routename != 'editGuideBook' &&
            !_vm.developer_guide_book
          )?_c('img',{staticClass:"px-2",attrs:{"src":require("@/assets/ic-manage-account_bw.svg"),"alt":""}}):_vm._e(),_c('span',[_vm._v("Error Guide Book")])])],1)]),_c('hr',{staticClass:"sidebar-divider d-none d-md-block"}),_c('div',{staticClass:"text-center d-none d-md-inline"}),_vm._v("\n  "+_vm._s(_vm.changeRoute())+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }